import { memo, ReactNode } from 'react';

import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';
import ModalDialog, { ModalBody, ModalHeader } from '@atlaskit/modal-dialog';

import i18n from '../i18n';
import { DialogContainer, DialogTitle } from '../styles';

interface DialogHeaderProps {
  intl: IntlShape;
  onClose: () => void;
}

const DialogHeader = injectIntl(
  memo((props: DialogHeaderProps) => {
    const { onClose, intl } = props;

    return (
      <ModalHeader>
        <DialogTitle>
          {intl.formatMessage(i18n.buildSummaryDialogHeading)}
        </DialogTitle>
        <IconButton
          label={intl.formatMessage(i18n.buildDialogCloseButton)}
          onClick={onClose}
          appearance="subtle"
          spacing="compact"
          icon={CrossIcon}
        />
      </ModalHeader>
    );
  })
);

type BuildStatusModalDialogProps = {
  children: ReactNode;
  onClose: () => void;
};

export const BuildStatusModalDialog = memo(
  (props: BuildStatusModalDialogProps) => (
    <ModalDialog width="medium" onClose={props.onClose}>
      <DialogContainer>
        <DialogHeader onClose={props.onClose} />
        <ModalBody>{props.children}</ModalBody>
      </DialogContainer>
    </ModalDialog>
  )
);
